export const JOINT_NAMES = [
  'joint0',
  'joint1',
  'joint2',
  'joint3',
  'joint4',
  'joint5',
] as const;
